import * as core from 'cw-ui-core';
import { CLIENT_ID, SCOPE } from './services/AuthService';

export const getOidcConfig = (configJson, apiUrl) => {
    const port = window.location.port ? `:${window.location.port}` : '';
    const currentUri = core.removeTrailingSlash(`${window.location.protocol}//${window.location.hostname}${port}`);

    const baseUrl = `${window.location.protocol}//${window.location.hostname}${port}`;

    const oidcUserManagerConfig = {
        client_id: CLIENT_ID,
        redirect_uri: `${currentUri}/signin-oidc`,
        response_type: 'code',
        scope: SCOPE.join(' '),
        post_logout_redirect_uri: currentUri,
        automaticSilentRenew: true,
        revokeAccessTokenOnSignout: true,
        authority: apiUrl,
        silent_redirect_uri: `${baseUrl}/silent_renew.html`,
        metadataUrl: `${apiUrl}/auth/metadata`,
        mergeClaimsStrategy: {
            array: 'replace',
        },
        response_mode: null,
        loadUserInfo: true,
        monitorSession: true,
        validateSubOnSilentRenew: true,
        includeIdTokenInSilentRenew: true,
        fetchRequestCredentials: 'include',
    };

    return oidcUserManagerConfig;
};
